<template>
    <div class="app-header" :class="{ 'app-header--fixed': isFixed, 'app-header--shifted': isShifted }">
        <div class="app-header__inner">
            <div class="app-header__main-bar row no-gutters flex-nowrap justify-content-end">
                <div v-if="productPathSegment !== null" class="app-header__group col d-flex justify-content-start">
                    <app-header-step-indication />
                </div>
                <!--<div class="app-header__group col-auto d-flex">
                    <div class="app-header__block app-header__block&#45;&#45;total-price col-auto d-flex flex-column justify-content-center">
                        <span class="app-header__block-label">{{ $t('priceCalculation.rentalPrice') }}</span>
                        <span class="app-header__block-text">{{ nEnhanced(totalPrice, 'currency') }}</span>
                    </div>
                </div>-->
                <div class="app-header__group col-auto d-flex">
                    <app-header-contact-area />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import AppHeaderStepIndication from '@/components/AppHeaderStepIndication'
import AppHeaderContactArea from '@/components/AppHeaderContactArea'

let voucherBar
// As the voucher bars initialization is delayed we can't get
// the height when the component is mounted, so we just set it.
const voucherBarHeight = 54

export default {
    name: 'AppHeader',
    components: {
        AppHeaderStepIndication,
        AppHeaderContactArea
    },
    data: () => ({
        isFixed: false,
        // shifting disabled for now
        isShifted: false
    }),
    computed: {
        ...mapGetters({
            totalPrice: 'totalPrice'
        }),
        ...mapState({
            productPathSegment: 'productPathSegment'
        })
    },
    methods: {
        handleScroll (event) {
            const offsetTop = this.$el.getBoundingClientRect().top + window.scrollY
            const shift = 0
            const topEdgeThreshold = offsetTop + shift

            this.isFixed = window.scrollY >= topEdgeThreshold

            // hide voucher/disclaimer bar, @see https://trello.com/c/IThWbDS6
            if (!voucherBar) return
            voucherBar.style.display = window.scrollY >= (topEdgeThreshold - voucherBarHeight) ? 'none' : ''
        }
    },
    created () {
        window.addEventListener('scroll', this.handleScroll)
    },
    mounted () {
        this.handleScroll()
        voucherBar = document.querySelector('.message.global.disclaimer .content')
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>

<style scoped>
    .app-header {
        position: relative;
        height: 50px;
        font-size: 12px;
        color: #545454;
    }
    .app-header__inner {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        height: 50px;
        background-color: #fff;
        box-shadow: 0 1px 10px 0 rgba(0, 0, 0, .2);
        /* stay below 200 (.page-header__inner) */
        z-index: 100;
        transition: transform .3s;
    }
    .app-header--fixed .app-header__inner {
        position: fixed;
    }
    .app-header--fixed.app-header--shifted .app-header__inner {
        transform: translateY(54px);
    }
    /* over-qualification intended, due to ".app .row" for > 768px */
    .app-header__main-bar.app-header__main-bar {
        max-width: 1200px;
        height: 100%;
        margin-left: auto;
        margin-right: auto;
    }
    .app-header__group {
        /* cannot apply overflow-hidden, would crop off the step indication dropdown */
    }
    .app-header__block {
        padding: 8px 10px;
        border-left: 1px solid #e6e6e6;
    }
    .app-header__block--total-price {
        text-align: right;
    }
    .app-header__block-label {
        display: block;
        white-space: nowrap;
    }
    .app-header__block-text {
        display: block;
        font-weight: 700;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    @media ( min-width: 768px ) {
        .app-header,
        .app-header__inner {
            height: 70px;
        }
    }

    @media ( min-width: 992px ) {
        .app-header {
            font-size: 13px;
        }
        .app-header__block {
            padding-left: 15px;
            padding-right: 15px;
            border-left: 0;
        }
    }
</style>
